import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { t } from 'i18next';
import {
  addCoachToGroupFailure,
  addCoachToGroupRequest,
  addCoachToGroupSuccess,
  editTeamMemberDataFailure,
  editTeamMemberDataRequest,
  editTeamMemberDataSuccess,
  fetchArchivedTeamMembersSuccess,
  fetchCoachGroupFailure,
  fetchCoachGroupRequest,
  fetchCoachGroupSuccess,
  IAddCoachToGroupInput,
  IEditCoachToGroupInput,
  IGetCoachGroupPayload,
} from './coachGroupSlice';
import {
  ADD_COACH_TO_GROUP,
  EDIT_TEAM_MEMBER,
  GET_COACH_GROUP,
} from '../../service/graphql/coachGroupQuery';
import client from '../../service/graphql';
import { toastStyles } from '../../utils/utils';

function* watchFetchCoachGroup({ payload }: PayloadAction<IGetCoachGroupPayload>) {
  try {
    const result = yield call(client.query.bind(client), {
      query: GET_COACH_GROUP,
      variables: { getCoachGroupInput: payload },
    });
    if (!payload.isactiveCoaches) {
      yield put(fetchArchivedTeamMembersSuccess(result.data.getCoachGroup));
    } else {
      yield put(fetchCoachGroupSuccess(result.data.getCoachGroup));
    }
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(fetchCoachGroupFailure(error.message));
    }
  }
}

function* watchAddCoachToGroup({ payload }: PayloadAction<IAddCoachToGroupInput>) {
  try {
    const result = yield call(client.mutate.bind(client), {
      mutation: ADD_COACH_TO_GROUP,
      variables: { input: payload },
    });
    yield put(addCoachToGroupSuccess(result.data.assignCoachToGroup));
    toast.success(t('addNewCoach.toastMessage.StaffMemberAdded'), toastStyles.success);
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(addCoachToGroupFailure(error.message));
      toast.error(error.message, toastStyles.error);
    }
  }
}

function* watchEditTemamMember({ payload }: PayloadAction<IEditCoachToGroupInput>) {
  try {
    const result = yield call(client.mutate.bind(client), {
      mutation: EDIT_TEAM_MEMBER,
      variables: { editTeamMemberDataInput: payload },
    });
    yield put(editTeamMemberDataSuccess(result.data.editTeamMemberData));
    toast.success(t('addNewCoach.toastMessage.StaffMemberUpdated'), toastStyles.success);
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(editTeamMemberDataFailure(error.message));
      toast.error(error.message, toastStyles.error);
    }
  }
}

export function* watchCoachGroupSagas() {
  yield takeLatest(fetchCoachGroupRequest, watchFetchCoachGroup);
  yield takeLatest(addCoachToGroupRequest, watchAddCoachToGroup);
  yield takeLatest(editTeamMemberDataRequest, watchEditTemamMember);
}

const coachGroupSagas = watchCoachGroupSagas;
export default coachGroupSagas;
